export default function initReveal() {
  const elements = document.querySelectorAll('[data-reveal]')
  if (!elements.length) return

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return

      let delay = parseInt(entry.target.dataset.revealDelay || 0, 10)

      const parent = entry.target.closest('[data-reveal-stagger]')
      if (parent) {
        const stagger = parseInt(parent.dataset.revealStagger || 100, 10)
        const siblings = Array.from(parent.querySelectorAll('[data-reveal]'))
        const index = siblings.indexOf(entry.target)
        delay += index * stagger
      }

      setTimeout(() => entry.target.classList.add('is-visible'), delay)
      io.unobserve(entry.target)
    })
  }, { threshold: 0.15, rootMargin: '0px 0px -80px 0px' })

  elements.forEach((el) => io.observe(el))
}
